import { getHeartIconStatus as getHeartCoinStatus } from "@/api/value-added";
import { isAuthUser } from "@/utils/status";
import { makeAutoObservable } from "mobx";

export interface HeartCoinInfo {
  free: number;
  total: number;
  payed: number;
  froze: number;
}

const defaultInfo: HeartCoinInfo = {
  free: 0,
  payed: 0,
  froze: 0,
  total: 0,
};
interface IWithResponse<T> {
  code: number;
  data: T;
  msg: string;
}

export interface HeartCoinData {
  free_balance: number;
  pay_balance: number;
  locked_balance: number;
  total_balance: number;
}

class UserAssets {
  heartCoinInfo: HeartCoinInfo = defaultInfo;
  heartCoinPayModalOpen = false;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setHeartCoinPayModalOpen = (open: boolean) => {
    this.heartCoinPayModalOpen = open;
  };

  closeHeartCoinPayModal = () => {
    this.setHeartCoinPayModalOpen(false);
  };

  onHeartCoinPaySuccess() {
    this.closeHeartCoinPayModal();
    let count = 0;
    const timer = setInterval(() => {
      this.fetchHeartCoin();
      count++;
      if (count >= 2) {
        clearInterval(timer);
      }
    }, 1500);
  }

  setHeartCoinInfo(info: HeartCoinData) {
    this.heartCoinInfo = {
      free: info.free_balance,
      froze: info.locked_balance,
      payed: info.pay_balance,
      total: info.total_balance,
    };
  }

  async fetchHeartCoin() {
    if (isAuthUser()) {
      const res: IWithResponse<HeartCoinData> = await getHeartCoinStatus();
      if (res.code === 0) {
        this.setHeartCoinInfo(res.data);
      }
      return res;
    }
  }
}

export const userAssetsStore = new UserAssets();

export enum UserAssetsEvent {
  "SHOW_HEART_COIN_MODAL" = "show_heart_coin_modal",
}
